module.exports = __webpack_public_path__ + "media/music/jazzy_bass_7-840e47cf.mp3";